import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const url = config.url || "";
  const adminToken = localStorage.getItem("nlcs_token");
  const custToken = localStorage.getItem("nlcs_customer_token");
  if (url.startsWith("/admin") || url.startsWith("/auth")) {
    if (adminToken) config.headers.Authorization = `Bearer ${adminToken}`;
  } else if (url.startsWith("/customer") || url.startsWith("/orders")) {
    if (custToken) config.headers.Authorization = `Bearer ${custToken}`;
  }
  return config;
});

export const gbp = (n) =>
  new Intl.NumberFormat("en-GB", { style: "currency", currency: "GBP" }).format(n || 0);

export const LOGO_URL =
  "https://static.prod-images.emergentagent.com/jobs/cdfa4a80-f820-45fa-9c4a-298c5ecb17aa/images/17def20283331da72de7c4cf8a7ea277646420f1c03844211a31b82c3a96e268.png";

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
